import { chain, uniqBy, sortBy, find, findIndex, filter } from 'lodash';
import { FETCH_CATEGORIES_SUCCESS } from '../actions/fetch-categories';
import { CREATE_CATEGORY_SUCCESS } from '../actions/create-category';
import {
  CATEGORIES_MANAGER_CREATE_CATEGORY,
  CATEGORIES_MANAGER_DELETE_CATEGORY,
  CATEGORIES_MANAGER_UPDATE_CATEGORY,
} from '../actions/categories-manager-actions-constants';
import { DELETE_CATEGORY_SUCCESS } from '../actions/delete-category';
import { UPDATE_CATEGORY_SUCCESS } from '../actions/update-category';
// import { CHANGE_CATEGORY_RANK } from '../actions/change-category-rank';
import { SET_CATEGORIES } from '../actions/set-categories';
import { UPDATE_CATEGORY_COUNTERS } from '../actions/category-socket';
import { SUBSCRIBE_REQUEST, SUBSCRIBE_FAILURE } from '../actions/subscribe';
import { UNSUBSCRIBE_REQUEST, UNSUBSCRIBE_FAILURE } from '../actions/unsubscribe';
import { FETCH_CATEGORY_SUCCESS } from '../actions/fetch-category';
import { UPDATE_CATEGORIES } from '../actions/update-categories';
import { CALCULATE_SUBCATEGORIES_PERMISSIONS } from '../actions/calculate-subcategories-permissions';

const initialState = [];
const SORT_BY = 'rank';

export default (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case UPDATE_CATEGORIES:
      return payload;
    case FETCH_CATEGORIES_SUCCESS:
      return sortBy(uniqBy([...state, ...payload], '_id'), SORT_BY);
    case FETCH_CATEGORY_SUCCESS:
    case CREATE_CATEGORY_SUCCESS:
    case CATEGORIES_MANAGER_CREATE_CATEGORY:
      return sortBy(uniqBy([...state, payload], '_id'), SORT_BY);
    case UPDATE_CATEGORY_COUNTERS:
    case UPDATE_CATEGORY_SUCCESS:
    case CATEGORIES_MANAGER_UPDATE_CATEGORY: {
      const categoryIndex = findIndex(state, category => category._id === payload._id);
      const category = state[categoryIndex];
      return category
        ? sortBy(
            [
              ...state.slice(0, categoryIndex),
              {
                ...category,
                ...payload,
              },
              ...state.slice(categoryIndex + 1, state.length),
            ],
            SORT_BY,
          )
        : state;
    }
    // case CHANGE_CATEGORY_RANK: {
    //   const { rank, categoryId } = payload;
    //   const category = find(state, category => category._id === categoryId);
    //   const tempState = filter(state, category => category._id !== categoryId);
    //
    //   tempState.splice(rank, 0, category);
    //   return chain(tempState)
    //     .map((category, rank) => ({
    //       ...category,
    //       rank,
    //     }))
    //     .sortBy(SORT_BY)
    //     .value();
    // }
    case DELETE_CATEGORY_SUCCESS:
    case CATEGORIES_MANAGER_DELETE_CATEGORY:
      return state.filter(category => category._id !== payload);
    case SET_CATEGORIES:
      return [...payload];
    case SUBSCRIBE_REQUEST:
      return setIsSubscribed(state, payload, true);

    case SUBSCRIBE_FAILURE:
      return setIsSubscribed(state, payload, false);

    case UNSUBSCRIBE_REQUEST:
      return setIsSubscribed(state, payload, false);

    case UNSUBSCRIBE_FAILURE:
      return setIsSubscribed(state, payload, true);
    case CALCULATE_SUBCATEGORIES_PERMISSIONS: {
      const getParent = parentId => state.find(c => c._id === parentId);
      return state.map(category => {
        if (category.parentId) {
          const parent = getParent(category.parentId);
          return {
            ...category,
            isPrivate: category.isPrivate || parent.isPrivate,
          };
        }
        return category;
      });
    }
    default:
      return state;
  }
};

function setIsSubscribed(state, { type, _id }, isSubscribed) {
  if (type !== 'category') {
    return state;
  }

  const index = findIndex(state, category => category._id === _id);
  return [
    ...state.slice(0, index),
    {
      ...state[index],
      isSubscribed,
    },
    ...state.slice(index + 1),
  ];
}
